import React, { useState, useEffect, Fragment } from 'react';
import { Image, Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer';
import { ShopInfo } from '../shopinfo';

const Invoice = (props) => {
  const [order, setOrder] = useState([]);
  const [orderItems, setOrderItems] = useState([]);

  useEffect(() => {
    setOrder(props.data);
    setOrderItems(props.data.items || []);
  }, [props.data]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB');
  };

  const styles = StyleSheet.create({
    page: {
      fontSize: 11,
      paddingTop: 20,
      paddingLeft: 40,
      paddingRight: 40,
      lineHeight: 1.5,
      flexDirection: 'column',
      flexGrow: 1,
      justifyContent: 'space-between',
      minHeight: '100%',
    },
    content: {
      flexGrow: 1,
    },
    footer: {
      paddingTop: 10,
      borderTopWidth: 1,
      borderColor: 'whitesmoke',
      textAlign: 'center',
    },
    spaceBetween: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: '#3E3E3E',
    },
    titleContainer: { flexDirection: 'row', marginTop: 24 },
    logo: { width: 90 },
    reportTitle: { fontSize: 16, textAlign: 'center' },
    addressTitle: { fontSize: 11, fontStyle: 'bold' },
    invoice: { fontWeight: 'bold', fontSize: 20 },
    invoiceNumber: { fontSize: 11, fontWeight: 'bold' },
    address: { fontWeight: 400, fontSize: 10 },
    theader: {
      marginTop: 20,
      fontSize: 10,
      fontStyle: 'bold',
      paddingTop: 4,
      paddingLeft: 7,
      flex: 1,
      height: 20,
      backgroundColor: '#DEDEDE',
      borderColor: 'whitesmoke',
      borderRightWidth: 1,
      borderBottomWidth: 1,
    },
    theader2: { flex: 2, borderRightWidth: 0, borderBottomWidth: 1 },
    tbody: {
      fontSize: 9,
      paddingTop: 4,
      paddingLeft: 7,
      flex: 1,
      borderColor: 'whitesmoke',
      borderRightWidth: 1,
      borderBottomWidth: 1,
    },
    total: {
      fontSize: 9,
      paddingTop: 4,
      paddingLeft: 7,
      flex: 1.5,
      borderColor: 'whitesmoke',
      borderBottomWidth: 1,
    },
    tbody2: { flex: 2, borderRightWidth: 1 },
  });

  const InvoiceTitle = () => (
    <View style={styles.titleContainer}>
      <View style={styles.spaceBetween}>
        <Image style={styles.logo} src={'/img/logo_web.png'} />
        <Text style={styles.reportTitle}>{ShopInfo.Name}</Text>
      </View>
    </View>
  );

  const Address = () => (
    <View style={styles.titleContainer}>
      <View style={styles.spaceBetween}>
        <View>
          <Text style={styles.invoice}>Invoice</Text>
          <Text style={styles.invoiceNumber}>Order : {order.orderId}</Text>
        </View>
        <View>
          <Text style={styles.addressTitle}>{ShopInfo.Name}</Text>
          <Text style={styles.address}>{ShopInfo.Address}</Text>
          <Text style={styles.address}>Phone: {ShopInfo.Phone}</Text>
            <Text style={styles.address}>GSTIN: {ShopInfo.GSTNumber}</Text>
        </View>
      </View>
    </View>
  );

  const UserAddress = () => (
    <View style={styles.titleContainer}>
      <View style={styles.spaceBetween}>
        <View style={{ maxWidth: 200 }}>
          <Text style={styles.addressTitle}>Bill To:</Text>
          <Text style={styles.address}>{order.name}</Text>
          <Text style={styles.address}>{order.address}</Text>
          {order.phoneNumber && <Text style={styles.address}>Phone: {order.phoneNumber}</Text>}
        </View>
        <Text style={styles.addressTitle}>Order date: {formatDate(order.createdAt)}</Text>
      </View>
    </View>
  );

  const TableHead = () => (
    <View style={{ width: '100%', flexDirection: 'row', marginTop: 10 }}>
      <View style={[styles.theader, styles.theader2]}>
        <Text>Items</Text>
      </View>
      <View style={styles.theader}>
        <Text>Price</Text>
      </View>
      <View style={styles.theader}>
        <Text>Qty</Text>
      </View>
      <View style={styles.theader}>
        <Text>Amount</Text>
      </View>
    </View>
  );

  const TableBody = () =>
    orderItems.map((item, idx) => (
      <Fragment key={idx}>
        <View style={{ width: '100%', flexDirection: 'row' }}>
          <View style={[styles.tbody, styles.tbody2]}>
            <Text>{item.name}</Text>
          </View>
          <View style={styles.tbody}>
            <Text>{item.price}</Text>
          </View>
          <View style={styles.tbody}>
            <Text>{item.quantity}</Text>
          </View>
          <View style={styles.tbody}>
            <Text>{(item.price * item.quantity).toFixed(2)}</Text>
          </View>
        </View>
      </Fragment>
    ));

  const TableTotal = () => {
    const totalProducts = orderItems.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );
    const gstRate = ShopInfo.gstRate || 0;
    const gstAmount = (totalProducts * gstRate).toFixed(2);
    const grandTotal = (totalProducts + parseFloat(gstAmount)).toFixed(2);

    return (
      <View style={{ width: '100%', flexDirection: 'column', marginTop: 10 }}>
        {/* Total of products */}
        <View style={{ width: '100%', flexDirection: 'row' }}>
          <View style={styles.total}><Text></Text></View>
          <View style={styles.total}><Text> </Text></View>
          <View style={styles.tbody}><Text>Total</Text></View>
          <View style={styles.tbody}><Text>{totalProducts.toFixed(2)}</Text></View>
        </View>

        {/* GST */}
        <View style={{ width: '100%', flexDirection: 'row' }}>
          <View style={styles.total}><Text></Text></View>
          <View style={styles.total}><Text> </Text></View>
          <View style={styles.tbody}><Text>GST ({(gstRate * 100).toFixed(0)}%)</Text></View>
          <View style={styles.tbody}><Text>{gstAmount}</Text></View>
        </View>

        {/* Grand Total */}
        <View style={{ width: '100%', flexDirection: 'row' }}>
          <View style={styles.total}><Text></Text></View>
          <View style={styles.total}><Text> </Text></View>
          <View style={styles.tbody}><Text>Grand Total</Text></View>
          <View style={styles.tbody}><Text>{grandTotal}</Text></View>
        </View>
      </View>
    );
  };

  const InvoiceFoot = () => (
    <View style={styles.footer}>
      <Text style={styles.addressTitle}>{ShopInfo.Name}</Text>
      <Text style={styles.address}>{ShopInfo.Address}</Text>
      <Text style={styles.address}>Phone: {ShopInfo.Phone}</Text>
      <Text style={styles.address}>Open: {ShopInfo.OpenTime} - {ShopInfo.CloseTime}</Text>
    </View>
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.content}>
          <InvoiceTitle />
          <Address />
          <UserAddress />
          <TableHead />
          <TableBody />
          <TableTotal />
        </View>
        <InvoiceFoot />
      </Page>
    </Document>
  );
};

export default Invoice;
